import {auth} from '../../lib/firebase';
import {attendanceRequest} from '../attendance/attendanceClient';

export const notePermissionError=error=>['permission-denied','firestore/permission-denied','storage/unauthorized','functions/permission-denied','unauthenticated','auth/user-token-expired'].includes(error?.code);
const repairs=new Map();
// A rule denial can race sign-in or an expired daily access decision. Repair
// only after a denial; ordinary typing never starts another access assessment.
async function repair(uid){
    if(auth.currentUser?.uid!==uid)throw Object.assign(new Error('Sign in again to save your notes.'),{code:'notes/session-changed'});
    const previous=repairs.get(uid);
    if(previous && (previous.running || Date.now()-previous.started<30000))return previous.promise;
    const entry={started:Date.now(),running:true,promise:null};
    entry.promise=(async()=>{
        await auth.currentUser.getIdToken(true);
        if(auth.currentUser?.uid!==uid)throw Object.assign(new Error('Your signed-in account changed.'),{code:'notes/session-changed'});
        // The server reuses today's decision when it is valid. Do not force a
        // new exam assessment and never bypass a real coordinator/exam hold.
        const decision=await attendanceRequest('status');
        if(!decision || decision.blocked!==false)throw Object.assign(new Error('Complete your pending exams or contact your coordinator to continue.'),{code:'notes/access-blocked'});
    })().finally(()=>{entry.running=false;});
    repairs.set(uid,entry);
    if(repairs.size>10)for(const [id,item] of repairs)if(!item.running&&id!==uid)repairs.delete(id);
    return entry.promise;
}
export async function withLectureNoteAccess(uid,operation){
    try{return await operation();}
    catch(error){
        if(!notePermissionError(error))throw error;
        await repair(uid);
        if(auth.currentUser?.uid!==uid)throw Object.assign(new Error('Your signed-in account changed.'),{code:'notes/session-changed'});
        return operation();
    }
}
export function lectureNoteError(error,loading=false){
    if(error?.code==='notes/access-blocked')return 'Your platform access needs attention. Complete your pending exams or contact your coordinator. Your notes have not been overwritten.';
    if(error?.code==='notes/session-changed')return 'Your signed-in account changed. Sign in again before continuing with these notes.';
    if(notePermissionError(error))return loading?'Your saved notes could not be opened because access was denied. Retry loading notes; if this continues, contact your coordinator.':'Access was denied while saving your notes. Keep this page open and retry saving; if this continues, contact your coordinator.';
    return loading?'Your saved notes could not load. Retry loading notes; no notes have been overwritten.':'Notes could not be saved. Keep this page open and retry.';
}
